module.exports = __webpack_public_path__ + "img/back-ground.13c5bd0a.png";